import React, { useEffect } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, ExternalLink, Shield } from "lucide-react";
import { cn } from "@/lib/utils";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_frog-ecodev/artifacts/3z4427yl_image.png";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userRoles = localStorage.getItem("user_roles") || "";
  const isAdmin = userRoles.includes("admin");

  useEffect(() => {
    if (!token || !isAdmin) {
      navigate("/portal/admin-login");
    }
  }, [token, isAdmin, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_roles");
    navigate("/");
  };

  if (!token || !isAdmin) return null;

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      {/* Admin Header */}
      <header className="bg-zinc-900 border-b border-zinc-700 sticky top-0 z-50">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/portal/admin/dashboard" className="flex items-center gap-4 group">
            <img src={LOGO_URL} alt="FL Logo" className="h-8 w-auto object-contain group-hover:opacity-80 transition-opacity" />
            <div className="flex items-center gap-2 border-l border-zinc-600 pl-4">
              <Shield className="h-4 w-4 text-primary" />
              <span className="text-sm font-heading font-bold uppercase tracking-wide text-white">
                Admin Panel
              </span>
            </div>
          </Link>

          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-xs font-bold text-gray-300 uppercase">
                {localStorage.getItem("user_email")?.split("@")[0]}
              </div>
              <a
                href="/"
                target="_blank"
                className="text-[10px] text-primary uppercase flex items-center justify-end hover:underline"
              >
                Main Site <ExternalLink className="ml-1 h-3 w-3" />
              </a>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="border-zinc-600 text-gray-300 hover:bg-zinc-800 uppercase text-xs font-bold tracking-wider"
              data-testid="admin-logout-btn"
            >
              <LogOut className="mr-2 h-3 w-3" />
              Sign Out
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-white border-t mt-auto py-6">
        <div className="container mx-auto px-4 text-center text-xs text-gray-500 uppercase tracking-wider">
          &copy; {new Date().getFullYear()} Frog Lake First Nations - Admin Panel
        </div>
      </footer>
    </div>
  );
};

export default AdminLayout;
